import { StatusBar, HomeBar, Wordmark, Button } from "./primitives";
import { PLAN, TONE } from "./data";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function S3({ spaStyle = "warm", animate = false }) {
  const an = (i, extra = "") => (animate ? { className: `an ${extra}`, style: { "--i": i } } : {});
  return (
    <div className={`still ${animate ? "animate" : ""}`} data-testid="still-s3" style={{ width: 1080, height: 1920 }}>
      <StatusBar time="6:05" />
      <div style={{ padding: "48px 72px 0", display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <Wordmark size={64} />
        <span style={{ fontSize: 30, color: "var(--ink-60)" }}>Request to book</span>
      </div>

      <div {...an(0)} style={{ ...an(0).style, margin: "70px 72px 0", background: "#fff", borderRadius: 44, border: "1px solid var(--ink-06)", overflow: "hidden", boxShadow: "0 30px 70px -44px rgba(31,31,31,.4)" }}>
        <div style={{ height: 300, position: "relative", background: "linear-gradient(135deg, #F6E1E4 0%, #FBF8F7 60%, #EAE4F8 100%)" }}>
          <img data-testid="s3-hero" alt="" src={`${BACKEND_URL}/api/files/aura_hero_${spaStyle}.png`} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(31,31,31,.45), rgba(31,31,31,0) 55%)" }} />
          <span style={{ position: "absolute", left: 40, bottom: 28, fontSize: 24, letterSpacing: "0.14em", textTransform: "uppercase", color: "#fff", fontWeight: 600 }}>{spaStyle === "loft" ? "SoHo · Loft" : "SoHo · Studio"}</span>
        </div>
        <div style={{ padding: "40px 44px 48px" }}>
          <div {...an(2)} className={`serif ${an(2).className || ""}`} style={{ ...an(2).style, fontSize: 64, fontWeight: 500, lineHeight: 1.05 }}>{PLAN.spa}</div>
          <div {...an(3)} style={{ ...an(3).style, marginTop: 10, fontSize: 30, color: "var(--ink-60)" }}>{PLAN.area} · 4.9 ★ · 0.4 mi · Does both services</div>

          <div style={{ marginTop: 44, borderTop: "1px solid var(--ink-06)" }}>
            {PLAN.services.map((s, i) => (
              <div key={s.name} {...an(4 + i)} style={{ ...an(4 + i).style, display: "flex", alignItems: "center", gap: 24, padding: "30px 0", borderBottom: "1px solid var(--ink-06)" }}>
                <span style={{ width: 18, height: 18, borderRadius: "50%", background: TONE[s.tone].bg, border: `3px solid ${TONE[s.tone].fg}` }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 36, fontWeight: 500 }}>{s.name}</div>
                  <div style={{ fontSize: 28, color: "var(--ink-60)", marginTop: 4 }}>{s.mins} min</div>
                </div>
                <div style={{ fontSize: 36, fontWeight: 500 }}>${s.price}</div>
              </div>
            ))}
          </div>

          <div {...an(7)} style={{ ...an(7).style, display: "flex", justifyContent: "space-between", padding: "30px 0 0", fontSize: 30, color: "var(--ink-60)" }}>
            <span>Preferred window</span><span style={{ color: "var(--charcoal)", fontWeight: 500 }}>{PLAN.window}</span>
          </div>
          <div {...an(8)} style={{ ...an(8).style, display: "flex", justifyContent: "space-between", padding: "22px 0 0", fontSize: 40, fontWeight: 600 }}>
            <span>Total</span><span>${PLAN.total}</span>
          </div>
        </div>
      </div>

      <div {...an(10)} style={{ ...an(10).style, position: "absolute", left: 72, right: 72, bottom: 120 }}>
        <Button size={38}>Send request to Aura</Button>
        <div style={{ textAlign: "center", marginTop: 26, fontSize: 28, color: "var(--ink-60)", lineHeight: 1.4 }}>
          Aura will suggest a plan. Nothing is charged until you confirm.
        </div>
      </div>
      <HomeBar />
    </div>
  );
}
